<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/admon')" style="cursor: pointer">Administración</li>
        <li class="breadcrumb-item" @click="$router.push('/admon/referidos')" style="cursor: pointer">Referidos</li>
        <li class="breadcrumb-item active" aria-current="page" v-if="referal != null">{{ referal.name }}</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <header>
        <div class="row" v-if="referal != null">
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                Referido
              </div>
              <div class="card-body">
                {{ referal.name }}
              </div>
            </div>

          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                Porcentaje
              </div>
              <div class="card-body">
                {{ referal.percentage }} %
              </div>
            </div>

          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-header">
                Clics
              </div>
              <div class="card-body">
                {{ referal.click }}
              </div>
            </div>
          </div>
        </div>
      </header>

      <div class="edit-zone" style="margin-top:10px">
        <div class="card">
          <div class="card-body">
            <div class="row">

              <div class="col-md-3">
                <div class="form-group mb-2">
                  <label>Porcentaje</label>
                  <input type="text" name="percentage" class="form-control" v-model="percentage">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>URI</label>
                  <input type="text" name="uri" class="form-control" v-model="uri">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Destino</label>
                  <input type="text" name="destiny" class="form-control" v-model="destiny">
                </div>
              </div>
              <div class="col-md-3">
                <button type="submit" class="btn btn-primary btn-raised" style="margin-top:20px;" v-on:click="update()">
                  Actualizar
                </button>
              </div>

            </div>
            <div class="row" v-if="referal != null">

              <div class="col-md-1">
                <div class="form-group mb-2">
                  <label>IID</label>
                  <input type="text" name="iid" class="form-control" v-model="iid" disabled>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label>UID</label>
                  <input type="text" name="uid" class="form-control" v-model="referal.maker_id" disabled>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Nombre</label>
                  <input type="text" name="name" class="form-control" v-model="name" disabled>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Email</label>
                  <input type="text" name="email" class="form-control" v-model="email" disabled>
                </div>
              </div>
              <div class="col-md-2">
                <button type="button" class="btn btn-primary btn-raised" v-on:click="showModal('asignar')">ASIGNAR
                  USUARIO
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-zone row justify-content-md-center" style="margin-top:20px;">
        <div class="col-md-5">
          <div class="card">
            <div class="card-body">
              <div class="md-layout-item" style="display: inline-block">
                <vs-select label="Año" v-model="year">
                  <vs-select-item 
                    :value="anio"
                    :text="anio"
                    :key="anio"></vs-select-item>
                </vs-select>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="result-zone" style="margin-top:20px;">
        <div class="card">
          <div class="card-body">
            <h5 class="modal-title">Últimos 12 pagos</h5>
            <table class="table table-hover">
              <thead class="thead-dark">
              <th>IID</th>
              <th>Concepto</th>
              <th>Comisión</th>
              <th>Referencia</th>
              <th>Fecha</th>
              </thead>
              <tbody>
              <tr v-for="payment in payments">
                <td style="text-align: center">{{ payment.investor_id }}</td>
                <td style="text-align: center">{{ payment.concept }}</td>
                <td align="right">{{ format_price(payment.amount, 2) }}</td>
                <td style="text-align: center">{{ payment.reference }}</td>
                <td style="text-align: center">{{ payment.created_at }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <div class="result-zone" style="margin-top:20px;">
        <div class="card">
          <div class="card-body">
            <table class="table table-hover">
              <thead class="thead-dark">
              <th>Mes</th>
              <th>U. Registrados</th>
              <th>U. Reg y activos</th>
              <th>Monto Invertido Total</th>
              <th>M. Invertido U. Reg U12 meses</th>
              <!--                            <th>Primera Inversión</th>-->
              <th>Comisión</th>
              <th>Acción</th>
              </thead>
              <tbody>
              <tr v-for="comision in comisiones">
                <td>{{ getMonthString(comision.month) }}</td>
                <td>{{ comision.registrados }}</td>
                <td>{{ comision.activos }}</td>
                <td align="right">{{ format_price(comision.inversion, 2) }}</td>
                <td align="right">{{ format_price(comision.inversionU12, 2) }}</td>
                <!--                                <td align="right">{{ format_price(comision.primera, 2) }}</td>-->
                <td align="right">{{ format_price(comision.inversionU12 * (referal.percentage / 100), 2) }}</td>
                <td align="right">
                  <button type="button" class="btn btn-outline-success" style="border-radius: 5px"
                          v-on:click="showModal('pagar', comision)">PAGAR
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <div class="charts-zone">
        <div class="row">
          <div class="col-md-6">
            <chart-referal-user-registered :data="userRegisteredData"></chart-referal-user-registered>
          </div>
          <div class="col-md-6">
            <chart-referal-amount-inverted :data="amountInvertedData"></chart-referal-amount-inverted>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL ASIGNAR  -->
    <div class="modal fade" ref="asignar" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Buscar Usuario</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    v-on:click="hideModal('asignar')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-11">
                    <input type="text" placeholder="Nombre, email..." class="form-control" v-model="search"
                           v-on:keyup.enter="buscarUsuario()">
                  </div>
                  <div class="col-md-1">
                    <button class="form-control btn btn-success btn-raised" style="font-size: 1px;padding-bottom: 2%;"
                            v-on:click="buscarUsuario()" :disabled="buscando">
                      <em class="material-icons" style="margin-top: -5px;">search</em>
                    </button>
                  </div>
                </div>
                <table class="table table-hover">
                  <tr>
                    <th>IID</th>
                    <th>UID</th>
                    <th>Nombre</th>
                    <th>Email</th>
                    <th>Acción</th>
                  </tr>
                  <tr v-for="renglon in dataU">
                    <td>{{ renglon.id }}</td>
                    <td>{{ renglon.user_id }}</td>
                    <td>{{ renglon.name }}</td>
                    <td>{{ renglon.email }}</td>
                    <td>
                      <button type="button" class="btn btn-outline-success" style="border-radius: 5px"
                              v-on:click="seleccionar(renglon.user_id)" data-dismiss="modal" aria-label="Close">
                        Seleccionar
                      </button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL PAGAR  -->
    <div class="modal fade" ref='pagar' tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content" v-if="referal != null && comision != null">
          <div class="modal-header">
            <h5 class="modal-title">Pago de Comisión - {{ comision.mes }} {{ year }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="hideModal('pagar')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <table style="margin-right: 4rem">
                  <tr>
                    <th style="font-weight: normal!important; text-align: left">Inversionista:</th>
                    <td style="padding-left:20px"><strong>{{ referal.name }}</strong></td>
                  </tr>
                  <tr>
                    <th style="font-weight: normal!important; text-align: left">Concepto:</th>
                    <td style="padding-left:20px"><strong>Bono Programa Referidos</strong></td>
                  </tr>
                  <tr style="border-bottom: inset thin">
                    <th style="font-weight: normal!important; text-align: left">Monto:</th>
                    <td style="padding-left:20px">
                      <strong>{{ format_price(comision.inversionU12 * (referal.percentage / 100), 2) }}</strong></td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-success" style="border-radius: 5px"
                      v-on:click="pagarComision()" data-dismiss="modal" aria-label="Close">CONFIRMAR
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
//let Vue = require('vue');
import {Currency} from "@/models/Security/Currency";

let CRUR = require('../charts/chart-referal-user-registered').default;
let CRAI = require('../charts/chart-referal-amount-inverted').default;
export default {
  name: 'referal',
  props: [''],
  components: {
    'chart-referal-user-registered': CRUR,
    'chart-referal-amount-inverted': CRAI,
  },
  mounted() {
    var date = new Date();
    this.year = date.getFullYear();
    this.month = date.getMonth() + 1;
    for (var i = date.getFullYear(); i >= 2016; i--) {
      this.years.push(i);
    }
    axios.get('/api/referals/' + this.referal_id).then((resolve) => {
      this.referal = resolve.data.referal;
      this.payments = resolve.data.payments;
      this.iid = resolve.data.iid;
      this.name = resolve.data.name;
      this.email = resolve.data.email;
      this.percentage = resolve.data.referal.percentage
      this.uri = resolve.data.referal.uri
      this.destiny = resolve.data.referal.destiny
    });
  },
  data() {
    return {
      referal: null,
      payments: [],
      iid: null,
      name: null,
      email: null,
      percentage: null,
      uri: null,
      destiny: null,
      year: '',
      month: '',
      comisiones: [],
      userRegisteredData: [],
      amountInvertedData: [],
      referal_id: this.$route.params.id,
      dataU: [],
      search: '',
      buscando: false,
      comision: null,
      years: [],
    }
  },
  methods: {
    format_price(value, decimales = 0) {
      let val = (value / 1).toFixed(decimales).replace(',', '.')
      return Currency.format(parseFloat(val))
    },
    update() {
      Vue.toasted.show('Actualizando...', {position: 'bottom-center', closeOnSwipe: false});
      axios.post('/api/referals/update/' + this.referal_id, {
        percentage: this.percentage,
        uri: this.uri,
        destiny: this.destiny
      }).then(response => {
        Vue.toasted.clear()
        Vue.toasted.show('¡¡ Referido actualizado !!', {
          position: 'bottom-center',
          type: 'success',
          closeOnSwipe: false,
          duration: 5000
        })
      }).catch(error => {
        Vue.toasted.clear()
        Vue.toasted.show('¡ERROR! Algo salió mal...', {
          position: 'bottom-center',
          type: 'error',
          closeOnSwipe: true,
          duration: 5000
        })
      });
    },
    showModal(destino, comision = null) {
      if (destino == "asignar") {
        let element = this.$refs.asignar;
        $(element).modal('show');
      }
      if (destino == "pagar") {
        this.comision = comision;
        let element = this.$refs.pagar;
        $(element).modal('show');
      }
    },
    hideModal(destino) {
      if (destino == "asignar") {
        let element = this.$refs.asignar;
        $(element).modal('hide');
      }
      if (destino == "pagar") {
        this.comision = null;
        let element = this.$refs.pagar;
        $(element).modal('hide');
      }
    },
    buscarUsuario() {
      if (this.buscando == false) {
        this.buscando = true;
        if (this.search.length >= 1) {
          axios.post('/api/referal/search', {
            search: this.search,
            origen: 'referidos',
          })
            .then(response => {
              this.dataU = response.data.users;
              this.buscando = false;
            });
        }
      }
    },
    seleccionar(user_id) {
      Vue.toasted.show('Asignando...', {position: 'bottom-center', closeOnSwipe: false});
      axios.post('/api/referal/asign', {
        user_id: user_id,
        referal_id: this.referal_id
      })
        .then(response => {
          Vue.toasted.clear()
          Vue.toasted.show('¡¡ Usuario Asignado !!', {
            position: 'bottom-center',
            type: 'success',
            closeOnSwipe: false,
            duration: 10000
          })
          axios.get('/api/referals/' + this.referal_id).then((resolve) => {
            this.referal = resolve.data.referal;
            this.payments = resolve.data.payments;
            this.iid = resolve.data.iid;
            this.name = resolve.data.name;
            this.email = resolve.data.email;
            this.percentage = resolve.data.referal.percentage
            this.uri = resolve.data.referal.uri
            this.destiny = resolve.data.referal.destiny
          });
        }).catch(error => {
        Vue.toasted.clear()
        Vue.toasted.show('¡ERROR! Algo salió mal...', {
          position: 'bottom-center',
          type: 'error',
          closeOnSwipe: true,
          duration: 10000
        })
      });
    },
    pagarComision() {
      Vue.toasted.show('Pagando...', {position: 'bottom-center', closeOnSwipe: false});
      axios.post('/api/pago-referidos', {
        referal_id: this.referal_id,
        amount: this.comision.inversionU12 * (this.referal.percentage / 100),
        mes: this.comision.mes,
        year: this.year
      }).then(response => {
        Vue.toasted.clear()
        Vue.toasted.show('¡¡ Pago exitoso !!', {
          position: 'bottom-center',
          type: 'success',
          closeOnSwipe: false,
          duration: 10000
        })
        axios.get('/api/referals/' + this.referal_id).then((resolve) => {
          this.referal = resolve.data.referal;
          this.payments = resolve.data.payments;
          this.iid = resolve.data.iid;
          this.name = resolve.data.name;
          this.email = resolve.data.email;
          this.percentage = resolve.data.referal.percentage
          this.uri = resolve.data.referal.uri
          this.destiny = resolve.data.referal.destiny
        });
      }).catch(error => {
        Vue.toasted.clear()
        Vue.toasted.show('¡ERROR! Nota: Revisa que este referido este asociado a un inversionista', {
          position: 'bottom-center',
          type: 'error',
          closeOnSwipe: true,
          duration: 10000
        })
      });
    },
    getMonthString($month) {
      switch ($month) {
        case 1: return "Enero";
        case 2: return "Febrero";
        case 3: return "Marzo";
        case 4: return "Abril";
        case 5: return "Mayo";
        case 6: return "Junio";
        case 7: return "Julio";
        case 8: return "Agosto";
        case 9: return "Septiembre";
        case 10: return "Octubre";
        case 11: return "Noviembre";
        case 12: return "Diciembre";
      }
    },
    loadCommissions() {
      if (this.year !== '' && this.month !== '') {
        Vue.toasted.show('Cargando Comisiones ' + this.year + '...', {position: 'bottom-center', closeOnSwipe: false});
        axios.post('/api/referals/comisiones/' + this.referal_id, {
          year: this.year
        }).then(response => {
          this.comisiones = response.data.data;
          this.userRegisteredData = response.data.userRegisteredData;
          this.amountInvertedData = response.data.amountInvertedData;
          Vue.toasted.clear()
          Vue.toasted.show('¡¡ Comisiones cargadas !!', {
            position: 'bottom-center',
            type: 'success',
            closeOnSwipe: false,
            duration: 5000
          })
        }).catch(error => {
          Vue.toasted.clear()
          Vue.toasted.show('¡ERROR! Algo salió mal...', {
            position: 'bottom-center',
            type: 'error',
            closeOnSwipe: true,
            duration: 5000
          })
        });
      }
    }
  },
  watch: {
    year: function () {
      this.loadCommissions();
    }
  }
}
</script>
